// extracted by mini-css-extract-plugin
export var brand = "_6l-9";
export var compact = "_6l-6";
export var extraSmall = "_6l-7";
export var icon = "_6l-0";
export var large = "_6l-4";
export var light = "_6l-1";
export var medium = "_6l-5";
export var outline = "_6l-b";
export var primaryDark = "_6l-a";
export var primaryLight = "_6l-8";
export var primaryModern = "_6l-c";
export var success = "_6l-2";
export var successSolid = "_6l-3";